<template>
    <qrcode-vue
        d-block
        :value="url"
        :size="size"
        level="H"
    />
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
    name: "QrCode",
    props: ['url'],
    data() {
        return {
            size: 300
        }
    },
    components: {
        QrcodeVue
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/fields/QrCode.vue